/**
 * class dependency:
 * - TextShape
 */

function NoneShape(draw, text, options) {
    TextShape.call(this, draw, text);
}

// extends
NoneShape.prototype = Object.create(TextShape.prototype);
NoneShape.prototype.constructor = NoneShape;